import styled from '@emotion/styled'

export const PointsContainer = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: flex-start;
  width: 600px;
`
